export class UserMeUpdateDTO {
  constructor(
    readonly email?: string,
    readonly language?: string,
    readonly phone?: string,
    readonly email_alarms?: boolean,
    readonly sms_alarms?: boolean,
    readonly cities_alarm?: string[],
    readonly accepted_license_agreement?: boolean,
  ) {}
}
